import { singUpStates } from "./signup/index";
import { countryCodeStates } from "./countryCodes";
import { auth } from "./auth";
import { businessType } from "./businessType";
import { trainingGroup } from "./trainingGroup";
import { shopcardStates } from "./shopCard";
import { template } from "./template";
import { members } from "./member";
import { userCamDigit } from "./confirmAccount";

export default {
  lan: "kh",
  auth,
  sign_up: singUpStates,
  countryCode: countryCodeStates,
  businessType,
  trainingGroup,
  shopcard: shopcardStates,
  template,
  members,
  userCamDigit
};
